import { Flex, Image } from "@chakra-ui/react";

const logo: string = require("icons/Pawtraits.svg").default;

export const PawtraitsSite = () => {
  return (
    <Flex
      h="100%"
      bgImage="url('https://firebasestorage.googleapis.com/v0/b/markcwy-portfolio.appspot.com/o/pawtraits%2FPudding_001.jpg?alt=media&token=f6c9d352-4aa2-47e6-aea9-befe6bf8c021')"
      bgSize="cover"
      bgRepeat="no-repeat"
      bgPos="center"
      align="center"
      justify="center"
    >
      <Image
        width="500px"
        maxWidth="50%"
        src={logo}
        alt="pawtraits logo"
        filter="drop-shadow(0 4px 20px rgba(0, 0, 0, 0.40))"
      />
    </Flex>
  );
};
